import { Component, Input } from '@angular/core';
import { FareFamily } from 'src/app/core/models/fare-family.model';

@Component({
  selector: 'app-fare-family',
  templateUrl: './fare-family.component.html',
  styleUrls: ['./fare-family.component.scss']
})
export class FareFamilyComponent {
  @Input() fareFamilies: FareFamily[];
  @Input() title: FareFamily[];
  @Input() isOriginal: boolean;

  showDropDown = false;

  constructor() {}
}
